<template>
  <v-container fluid>
    <v-row class="mb-4" v-if="areaSelected">
      <v-col
        class="
          box-white
          text-center
          py-1
          text-subtitle-2
          text-sm-subtitle-1
          text-md-subtitle-1
          text-lg-subtitle-1
          text-xl-subtitle-1
        "
      >
        <span v-if="areaSelected">
          {{ areaSelected.name }}
        </span>
      </v-col>
    </v-row>
    <v-row class="d-flex justify-center my-0 py-0" v-if="!areaSelected">
      <v-col cols="12" xl="7" lg="7" md="7" sm="7">
        <v-autocomplete
          v-model="statusSelected"
          dense
          hide-details=""
          @change="selectionChanged"
          :items="items"
          item-text="name"
          label="Tipo de bitácora"
          background-color="white"
          outlined
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-row v-if="loading">
          <v-col cols="12" v-for="item in 6" :key="item" class="py-2">
            <v-skeleton-loader type="list-item-avatar-three-line" />
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col
            cols="12"
            xl="4"
            lg="4"
            md="4"
            sm="6"
            xs="12"
            v-for="log in logs"
            :key="log._id"
            no-gutters
            class="py-2"
          >
            <log-field-item :log="log"></log-field-item>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div class="overlayCenter" v-if="!loading && logs.length <= 0">
      <p class="text-center">No hay registros en bitácora</p>
    </div>
    <!-- copyright -->
    <v-footer class="text-caption text-center d-flex justify-center" fixed>
      D.R. © Solena Ag, Inc. {{new Date().getFullYear()}}
    </v-footer>
  </v-container>
</template>

<script>
import LogFieldItem from "@/components/territory/LogFieldItem.vue";
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      page: 0,
      isMoreData: true,
      area_selected_input: "",
      areasListFiltered: [],
      areasLabels: [],
      logs: [],
      loading: false,
      busyGettingData: false,
      statusSelected: null,
      items: [
        { name: "Todos", value: "CLIENT" },
        { name: "Prospecto", value: "PROSPECT" },
      ],
    };
  },
  components: {
    LogFieldItem,
  },
  computed: {
    ...mapState("areasList", ["soilAreas", "areaSelected"]),
    ...mapState("logs", ["area_selected"]),
  },
  async created() {
    try {
      if (!this.areaSelected && this.$route.params.areaId) {
        let response = await this.getAreaById(this.$route.params.areaId);
        if (response) {
          if (!response.error) {
            this.SET_AREA_SELECTED(response.soilArea);
            await this.init();
          } else {
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text: "Algo salio mal al cargar bitácoras !!, intente de nuevo",
              timeout: 4000,
            });
          }
        } else {
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: "Algo salio mal al cargar bitácoras !!, intente de nuevo",
            timeout: 4000,
          });
        }
      } else {
        this.init();
      }
    } catch (e) {
      console.log(e);
      this.SET_ALERT_TYPE({
        visible: true,
        type: "error",
        text: "Algo salio mal al cargar bitácoras !!, intente de nuevo",
        timeout: 4000,
      });
    }
  },
  methods: {
    ...mapActions("areasList", ["fetchAllAreas", "getAreaById"]),
    ...mapActions("logs", [
      "getLogsByArea",
      "getLogsByProspect",
      "getLogsByClient",
    ]),
    ...mapMutations("logs", ["SET_AREA_SELECTED_LOGS"]),
    ...mapMutations(["SET_APPBAR_OPTIONS"]),
    ...mapMutations("areasList", ["SET_AREA_SELECTED"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    goBack() {
      this.$router.push(`/seller-list/client/`);
    },
    async init() {
      try {
        // check if area is selected
        if (this.$route.params.areaId) {
          this.loading = true;

          //fetch logs
          const res = await this.getLogsByArea({
            areaId: this.$route.params.areaId,
            page: this.page,
          });
          if (res) {
            if (!res.error) {
              this.logs = res.logBooks;
              this.page++;
              window.addEventListener("scroll", this.handleScroll);
              this.SET_APPBAR_OPTIONS({
                leftButton: "back-arrow",
                funcLeftButton: this.goBack,
              });
            } else {
              console.log(res.message);
              this.SET_ALERT_TYPE({
                visible: true,
                type: "error",
                text: "Algo salio mal al cargar bitácoras !!, intente de nuevo",
                timeout: 4000,
              });
            }
          } else {
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text: "Algo salio mal al cargar bitácoras !!, intente de nuevo",
              timeout: 4000,
            });
          }
        } else {
          this.loading = true;
          let client = null;
          let user = JSON.parse(localStorage.getItem("user"));
          if (user.role == "ORG_USER" || user.role == "ORG_USER_ADMIN") {
            client = localStorage.getItem("organizationId");
            this.SET_APPBAR_OPTIONS({
              leftButton: "menu",
            });
          } else {
            client = localStorage.getItem("clientId");
            this.SET_APPBAR_OPTIONS({
              leftButton: "menu_seller",
              funcLeftButton: this.goBack,
            });
          }
          this.statusSelected = "CLIENT";
          //fetch logs
          const res = await this.getLogsByClient({
            type: this.statusSelected,
            page: this.page,
            client: client,
          });
          if (res) {
            if (!res.error) {
              this.logs = res.logBooks;
              this.page++;
              window.addEventListener("scroll", this.handleScroll);
            } else {
              console.log(res.message);
              this.SET_ALERT_TYPE({
                visible: true,
                type: "error",
                text: "Algo salio mal al cargar bitácoras !!, intente de nuevo",
                timeout: 4000,
              });
            }
          } else {
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text: "Algo salio mal al cargar bitácoras !!, intente de nuevo",
              timeout: 4000,
            });
          }
        }
      } catch (e) {
        console.log(e);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal al cargar bitácoras !!, intente de nuevo",
          timeout: 4000,
        });
      }
      this.loading = false;
    },
    destroyed() {
      window.removeEventListener("scroll", this.handleScroll);
    },
    async handleScroll() {
      if (
        window.scrollY + window.innerHeight >=
        document.body.scrollHeight - 50
      ) {
        if (this.$route.params.areaId) {
          if (this.isMoreData) {
            if (this.busyGettingData) return;
            this.busyGettingData = true;
            let response = await this.getLogsByArea({
              areaId: this.$route.params.areaId,
              page: this.page,
            });
            if (response) {
              if (!response.error) {
                this.logs.push(...response.logBooks);
                this.page++;
                if (response.logBooks.length <= 0) {
                  this.isMoreData = false;
                }
              } else {
                console.log(response.message);
                this.SET_ALERT_TYPE({
                  visible: true,
                  type: "error",
                  text: "Algo salio mal al cargar bitácoras !!, intente de nuevo",
                  timeout: 4000,
                });
              }
            } else {
              this.SET_ALERT_TYPE({
                visible: true,
                type: "error",
                text: "Algo salio mal al cargar bitácoras !!, intente de nuevo",
                timeout: 4000,
              });
            }
          }
        } else {
          if (this.isMoreData) {
            let client = null;
            let user = JSON.parse(localStorage.getItem("user"));
            if (user.role == "ORG_USER" || user.role == "ORG_USER_ADMIN") {
              client = localStorage.getItem("organizationId");
            } else {
              client = localStorage.getItem("clientId");
            }
            this.busyGettingData = true;
            let response = await this.getLogsByClient({
              type: this.statusSelected,
              page: this.page,
              client: client,
            });
            if (response) {
              if (!response.error) {
                this.logs.push(...response.logBooks);
                this.page++;
                if (response.logBooks.length <= 0) {
                  this.isMoreData = false;
                }
              } else {
                console.log(response.message);
                this.SET_ALERT_TYPE({
                  visible: true,
                  type: "error",
                  text: "Algo salio mal al cargar bitácoras !!, intente de nuevo",
                  timeout: 4000,
                });
              }
            } else {
              this.SET_ALERT_TYPE({
                visible: true,
                type: "error",
                text: "Algo salio mal al cargar bitácoras !!, intente de nuevo",
                timeout: 4000,
              });
            }
          }
        }
        this.busyGettingData = false;
      }
    },
    async selectionChanged() {
      try {
        this.loading = true;
        this.page = 0;
        this.isMoreData = true;
        let client = null;
        let user = JSON.parse(localStorage.getItem("user"));
        if (user.role == "ORG_USER" || user.role == "ORG_USER_ADMIN") {
          client = localStorage.getItem("organizationId");
        } else {
          client = localStorage.getItem("clientId");
        }
        //fetch logs
        const res = await this.getLogsByClient({
          type: this.statusSelected,
          page: this.page,
          client: client,
        });
        if (res) {
          if (!res.error) {
            this.logs = res.logBooks;
            this.page++;
          } else {
            console.log(res.message);
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text: "Algo salio mal al cargar bitácoras !!, intente de nuevo",
              timeout: 4000,
            });
          }
        } else {
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: "Algo salio mal al cargar bitácoras !!, intente de nuevo",
            timeout: 4000,
          });
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal al cargar bitácoras !!, intente de nuevo",
          timeout: 4000,
        });
      }
    },
    async flipShow() {
      //fetch
      let response = await this.getLogsByArea(area_selected._id);
      this.logs = response.logBooks;
    },
    goBack() {
      this.$router.back();
    },
    async loadProspectLogBook() {
      let orgId = null;
      let user = JSON.parse(localStorage.getItem("user"));
      if (user.role == "ORG_USER" || user.role == "ORG_USER_ADMIN") {
        orgId = localStorage.getItem("organizationId");
      } else {
        orgId = localStorage.getItem("clientId");
      }

      const res = await this.getLogsByProspect(orgId);
      this.logs = res.logBooks;
    },
  },
};
</script>

<style scoped>
.box-white {
  background: #ffffff;
}
.overlayCenter {
  display: fixed;
  flex: 100%;
  top: 50%;
  left: 20%;
  right: 20%;
  bottom: 50%;
  z-index: 1;
  position: absolute;
}
</style>